var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVetor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 53.414L20.414 45H22v-2h-1v-1h-2v1.586L10.586 52H0v12h12V53.414zM10 62H2v-8h8v8zM52 10.586L43.586 19H42v2h1v1h2v-1.586L53.414 12H64V0H52v10.586zM54 2h8v8h-8V2zM24 19h4v2h-4zM36 19h4v2h-4zM30 19h4v2h-4zM21 21h1v-2h-3v3h2zM19 36h2v4h-2zM19 24h2v4h-2zM19 30h2v4h-2zM24 43h4v2h-4zM30 43h4v2h-4zM36 43h4v2h-4zM43 43h-1v2h3v-3h-2zM43 30h2v4h-2zM43 36h2v4h-2zM43 24h2v4h-2zM25 33h6v6h2v-6h6v-2h-6v-6h-2v6h-6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVetor);
export default __webpack_public_path__ + "static/media/vetor.de9feec86d8b5c5191019e7fac34fdf2.svg";
export { ForwardRef as ReactComponent };